module.exports = __webpack_public_path__ + "img/tpc-web-10.03f4e98a.jpg";